/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {CCInbox, MessageWithStatus} from "@app/ir-q-app-common/types/message-api";

export type ChatsMap = { [_id: string]: CCInbox };
export type MessagesMap = { [_id: string]: MessageWithStatus[] };
export type isSendingToChatMap = { [_id: string]: boolean | undefined };

export type ChatsContextType = {
    chats?: ChatsMap
    messages?: MessagesMap
    saveMessages: (messages: MessageWithStatus[]) => void
    updateMessages: (messages: MessageWithStatus[]) => void
    saveChats: (chats?: CCInbox[]) => void
    alreadyInitialized: boolean
    setAlreadyInitialized: () => void
    isSendingToChat: isSendingToChatMap
    setIsSendingToChat: (key: string, value: boolean) => void
}

export const ChatsContext = React.createContext<ChatsContextType>({
    chats: {},
    messages: {},
    saveMessages: (msgs) => {},
    updateMessages: (msgs) => {},
    saveChats: (chats?) => {},
    alreadyInitialized: false,
    setAlreadyInitialized: () => {},
    isSendingToChat: {},
    setIsSendingToChat: (key, value) => {}
});